import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import HomePage from './HomePage'; // Assuming HomePage.tsx is in the src directory
import LoginPage from './LoginPage';
import DashboardPage from './DashboardPage';
import ProtectedRoute from './ProtectedRoute';
import MembersListPage from './MembersListPage';
import UserManagement from './UserManagement';
import RoleProtectedRoute from './RoleProtectedRoute';
import DashboardLayout from './DashboardLayout';
import AddMemberPage from './AddMemberPage';
import MyProfilePage from './MyProfilePage';
import WalletPage from './WalletPage';
import TransactionManagement from './TransactionManagement';
import TermsPage from './TermsPage';
import PrivacyPolicyPage from './PrivacyPolicyPage';
import PlanDetailsPage from './PlanDetailsPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      
      {/* Routes with Sidebar Layout */}
      <Route element={<ProtectedRoute />}>
        <Route element={<DashboardLayout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/members" element={<MembersListPage />} />
          <Route path="/profile" element={<MyProfilePage />} />
          <Route path="/add-member" element={<AddMemberPage />} />
          <Route path="/wallet" element={<WalletPage />} />
          <Route path="/plan-details" element={<PlanDetailsPage />} />
          <Route element={<RoleProtectedRoute allowedRoles={['admin']} />}>
            <Route path="/admin/users" element={<UserManagement />} />
            <Route path="/admin/transactions" element={<TransactionManagement />} />
          </Route>
        </Route>
      </Route>

      {/* Redirect any unknown paths to the home page */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}



export default App;
